import articleStyles from './ArticlesContentStyles.module.scss'

export const BLOG_STYLES = {
    'header-one': articleStyles['blog-article__header-one'],
    'header-two': articleStyles['blog-article__header-two'],
    'header-three': articleStyles['blog-article__header-three'],
    'header-four': articleStyles['blog-article__header-four'],
    'header-five': articleStyles['blog-article__header-five'],
    'header-six': articleStyles['blog-article__header-six'],
    'unstyled': articleStyles['blog-article__unstyled'],
    'paragraph': articleStyles['blog-article__paragraph'],
    'blockquote': articleStyles['blog-article__blockquote'],
    'code-block': articleStyles['blog-article__code-block'],
    'unordered-list-item': articleStyles['blog-article__unordered-list-item'],
    'ordered-list-item': articleStyles['blog-article__ordered-list-item']
}

function getFullDate(date) {

    let dateUTC = new Date(date);
    let month = dateUTC.toLocaleString('default', {month: 'short'});
    let day = dateUTC.getDate();
    let year = dateUTC.getFullYear();

    return day + ' ' + month + ', ' + year;
}

export function formatArticleDate(created, updated) {

    let createdDate = null, updatedDate = null;
    let currentDateISO = new Date().toISOString(); // get UTC time in ISO format
    let parsedCurrentTime = new Date(currentDateISO); // parse ISO format to javascript defaults by passing ISO time as argument

    if (created) {
        createdDate = getFullDate(created);
    }

    if (!!updated && updated !== created) {

        let updatedUTC = new Date(updated);
        let difference = (parsedCurrentTime.getTime() - updatedUTC.getTime());
        // difference counting user's timezone offset in milliseconds
        difference = difference + parsedCurrentTime.getTimezoneOffset() * 1000 * 60;
        let differenceInMinutes = difference / (1000 * 60);
        let differenceInHours = difference / (1000 * 3600);
        let differenceInDays = difference / (1000 * 3600 * 24);

        switch (true) {
            case differenceInMinutes < 1 :
                updatedDate = 'a minute ago';
                break;
            case differenceInMinutes < 60 :
                updatedDate = `${Math.ceil(differenceInMinutes)} minutes ago`;
                break;
            case differenceInHours < 1 :
                updatedDate = 'an hour ago';
                break;
            case differenceInDays < 1 :
                updatedDate = `${Math.ceil(differenceInHours)} hours ago`;
                break;
            case differenceInDays > 1 && differenceInDays < 30:
                updatedDate = `${Math.floor(differenceInDays)} ${differenceInDays < 2 ? 'day' : 'days'} ago`;
                break;
            default:
                updatedDate = getFullDate(updated);
        }
    }

    return {
        createdDate: createdDate,
        updatedDate: updatedDate
    }
}